/**
 * AG Grid 컬럼 정렬·셀 스타일 유틸 (모듈 스코프 — 참조 안정)
 */
import { CellStyle } from "ag-grid-community";

/** 문자열 셀 정렬 */
export const cellStringComparator = (valueA: string, valueB: string): number => {
	if (!valueA && !valueB) return 0;
	if (!valueA) return -1;
	if (!valueB) return 1;
	return valueA.localeCompare(valueB);
};

/** 날짜 셀 정렬 */
export const cellDateComparator = (valueA: Date, valueB: Date): number => {
	if (!valueA && !valueB) return 0;
	if (!valueA) return -1;
	if (!valueB) return 1;

	const aTime = new Date(valueA).getTime();
	const bTime = new Date(valueB).getTime();
	return aTime - bTime;
};

/**
 * 터치 그리드용 cellStyle 팩토리.
 * 정렬(좌/우/하단 중앙)만 담당 — 선택/호버는 rowClassRules 사용.
 */
export const onlyTouchGridStyle = (
	idKey: string,
	centerBottomKey: string,
) => {
	return (params: any): CellStyle => {
		const { data } = params;

		if (params.node.rowPinned === 'bottom') {
			if (centerBottomKey === idKey) {
				return { textAlign: 'center', justifyContent: 'center' };
			}

			if (
				typeof data[idKey] === 'number'
				|| (typeof data[idKey] === 'string' && !isNaN(parseFloat(String(data[idKey]).replace(/,/g, ''))))
			) {
				return { cursor: 'default', textAlign: 'right', justifyContent: 'flex-end' };
			}
			return {};
		}

		const isNumberType = typeof data[idKey] === 'number';
		return {
			cursor: 'default',
			textAlign: isNumberType ? 'right' : 'left',
			justifyContent: isNumberType ? 'flex-end' : 'flex-start',
		};
	};
};
